import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async (params) => {
  return await dponetAPI.post('/dai_chats', params)
}

const get = async ({ daiChatId }) => {
  return await dponetAPI.get(`/dai_chats/${daiChatId}`)
}

export default {
  create,
  get,
}
